/** Значения, общие для событий аналитики. */
import { z } from "zod";

/** Где показали покупку. */
export const OfferPlace = z.enum(["defeat", "speed", "auto", "season", "boss"]);
export type OfferPlace = z.infer<typeof OfferPlace>;

/** Чем кончилась покупка: статус `openInvoice` или `error`, если счёт не выписан. */
export const PurchaseStatus = z.enum(["paid", "free", "cancelled", "failed", "pending", "error"]);
export type PurchaseStatus = z.infer<typeof PurchaseStatus>;

/** Случайный id сессии: склеивает `session_start` и `session_end`, с игроком не связан. */
export const SessionId = z.string().min(1).max(16);
